import React, { useState, lazy, Suspense } from 'react';
import bankImage from '../../assets/images/bank.png';
import alertIcon from '../../assets/images/alert.svg';
import './bank-statement-sample-modal.styles.scss';

const Modal = lazy(() => import('components/commons/modal'));

const BankStatementSampleModal: React.FC = (): JSX.Element => {
    const [visible, setVisible] = useState(false);

    return (
        <Suspense fallback="">
            <a
                href={void(0)}
                className="medium"
                onClick={() => setVisible(true)}
            >
                precisa de ajuda com este documento?
            </a>

            <Modal
                title=""
                visible={visible}
                onClose={() => setVisible(false)}
            >

                <div className="c-modal__bank">
                    <div className="title mb-4">
                        informações que buscamos no seu extrato bancário
                    </div>
                    <div className="d-flex mb-5">
                        <div className="c-modal__bank__avatar">seu banco</div>
                        <div className="c-modal__bank__subtitles">
                            <div>
                                nome titular
                            </div>
                            <div className="c-modal__agency">
                                agência   /   conta
                            </div>
                        </div>
                    </div>
                    <img
                        className="w-full mb-4"
                        src={bankImage}
                        alt="Faturamento da sua empresa"
                    />
                    <p className="d-flex body-2">
                        <div className="mr-3">
                            <img src={alertIcon} alt="Icone de alerta" className="c-alert__icon"/>
                        </div>
                        O seu extrato deve ser emitido preferencialmente pelo internet banking do seu banco. O modelo pode variar de acordo com cada instituição.
                    </p>
                </div>
            </Modal>
        </Suspense>
    );
};

export default BankStatementSampleModal;
